'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { cx } from '../../../internal/cx.js';
import { CopyButton } from '../copy-button/index.js';
import { useFieldContext } from '../../forms/form-field/index.js';
import { Input, Textarea } from '../../forms/text-field/index.js';
const selectAll = (event) => event.currentTarget.select();
/**
 * A read-only value with a copy button: webhook URLs, DNS records, embed
 * snippets, calendar feed links. If copying fails, the value is focused and
 * selected so the user can copy it by hand.
 */
export const CopyField = forwardRef(function CopyField({ value, label, multiline = false, rows = 3, mono = true, size = 'md', selectOnFocus = true, iconOnly = false, copyLabel = 'Copy', copiedLabel = 'Copied', resetAfter = 2000, onCopy, onCopyError, disabled, copyButtonProps, className, ...rest }, ref) {
    const field = useFieldContext();
    const controlRef = useRef(null);
    const control = {
        // Inside a Field the visible FieldLabel names the control; outside, `label` does.
        ...(field ? {} : { 'aria-label': label }),
        value,
        readOnly: true,
        disabled,
        spellCheck: false,
        autoComplete: 'off',
        onFocus: selectOnFocus ? selectAll : undefined,
        className: 'mn-copy-field__control',
    };
    return (_jsxs("div", { ref: ref, ...rest, className: cx('mn-copy-field', className), "data-multiline": multiline || undefined, "data-mono": mono || undefined, "data-size": size, children: [multiline ? (_jsx(Textarea, { ref: controlRef, ...control, rows: rows, resizable: false })) : (_jsx(Input, { ref: controlRef, ...control, size: size })), _jsx(CopyButton, { ...copyButtonProps, value: value, label: copyLabel, target: label, copiedLabel: copiedLabel, iconOnly: iconOnly, size: size, resetAfter: resetAfter, disabled: disabled, ...(onCopy ? { onCopy } : {}), onCopyError: (error) => {
                    const el = controlRef.current;
                    if (el) {
                        el.focus();
                        el.select();
                    }
                    onCopyError?.(error);
                }, className: cx('mn-copy-field__button', copyButtonProps?.className) })] }));
});
//# sourceMappingURL=copy-field.js.map